import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Statistics from "./Statistics";
import { getSidekickStatistics } from "../../../redux/slices/sidekickStatSlice";
import { SlCalender } from "react-icons/sl";
import DatePicker from "react-datepicker";

const SidekickDashboard = () => {
  const filters = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last Week", value: "lastweek" },
    { label: "This Week", value: "thisweek" },
    { label: "Last Month", value: "lastmonth" },
    { label: "This Month", value: "thismonth" },
    { label: "All Time", value: "alltime" },
  ];

  const dispatch = useDispatch();
  const [activeFilter, setActiveFilter] = useState("today");

  const { statistics, isLoading } = useSelector(
    (state) => state.sidekickstatReducer
  );

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const formatDate = (date) => date.toISOString().split(".")[0] + "Z";

  useEffect(() => {
    if (!startDate && !endDate) {
      const payload = {
        date: activeFilter,
      };
      dispatch(getSidekickStatistics(payload));
    }
  }, [activeFilter, startDate, endDate, dispatch]);

  useEffect(() => {
    if (startDate && endDate) {
      const adjustedStart = new Date(startDate.setHours(0, 0, 0, 0));
      // adjustedStart.setUTCHours(0, 0, 0, 0);
      const adjustedEnd = new Date(endDate.setHours(23, 59, 59, 999));
      // adjustedEnd.setUTCHours(23, 59, 59, 0);
      const payload = {
        startDate: adjustedStart,
        endDate: adjustedEnd,
      };

      dispatch(getSidekickStatistics(payload));
    }
  }, [startDate, endDate, dispatch, activeFilter]);

  const handleFilters = (value) => {
    setActiveFilter(value);
    setDateRange([null, null]);
  };

  return (
    <>
      <h1 className="text-left text-white text-3xl font-bold ml-5">
        Subscription Statistics
      </h1>
      <div className="flex items-center gap-2 my-2 p-4">
        {filters.map(({ label, value }) => (
          <button
            key={value}
            type="button"
            className={`rounded-full w-[82px] py-[10px] text-sm ${
              activeFilter === value
                ? "bg-white text-black font-semibold"
                : "bg-[#372F5B] text-white hover:font-semibold"
            }`}
            onClick={() => handleFilters(value)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="px-8 flex items-center gap-4">
        <label className="text-white font-medium">
          <SlCalender size={30} />
        </label>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => {
            setDateRange(update);
            if (update[0] && update[1]) {
              setActiveFilter("");
            }
            if (!update[0] && !update[1]) {
              setActiveFilter("today");
            }
          }}
          dateFormat="yyyy-MM-dd"
          className="pr-7 pl-3 py-2 rounded bg-white text-black"
          isClearable
          placeholderText="Select start and end date"
        />
      </div>
      <div className="p-4 bg-[#150C3F] transition-all duration-300 h-full mb-8">
        <Statistics dashboard={statistics} isLoading={isLoading} />
      </div>
    </>
  );
};

export default SidekickDashboard;
